export default "__VITE_ASSET__eJG0AP$d__"